<template>
  <div class="steptThree">
    <div class="userInfo">
      <!-- 购卡人联系电话 -->
      <div class="userInfoItem">
        <div class="userInfoItem_title">购卡人联系电话</div>
        <div class="userInfoItem_con">
          <el-input
            class="buyUserPhoneInp"
            placeholder="此电话可用来查询订单信息，请认真填写"
            maxlength="11"
            minlength="11"
            v-model="buyUserPhone"
            clearable>
          </el-input>
          <span style="font-size:12px;color:red;padding-left:10px;">*请填写您常用的联系电话，此电话将作为您查询订单的唯一依据，请认真填写</span>
        </div>
      </div>

      <!-- 收货信息 -->
      <div class="userInfoItem">
        <div class="userInfoItem_title">收货信息</div>
        <div class="userInfoItem_con">
          <div>
            <el-input class="userName" placeholder="收货人姓名" maxlength="20" v-model="userName" clearable> </el-input>
            <el-input class="userPhone" placeholder="收货人联系电话" maxlength="11" v-model="userPhone" clearable> </el-input>
          </div>
          <div>
            <el-cascader class="userAdd" placeholder="选择省/市" :options="options" :props="{expandTrigger: 'hover'}" v-model="userAdd" clearable @change="addChange(userAdd)"></el-cascader>
          </div>
          <div>
            <el-input class="userAddInfo" type="textarea" maxlength="100" resize="none" show-word-limit :rows="5" placeholder="请输入详细地址" v-model="userAddInfo"> </el-input>
          </div>
        </div>
      </div>

      <!-- 购卡实名 -->
      <div class="userInfoItem idcard_box" v-if="needImg==1">
        <div class="userInfoItem_title">购卡实名
          <span class="tip cursor" @click="tipFunc">注意事项</span>
        </div>
        <div class="userInfoItem_con idcard_list">
          <!-- 正面 -->
          <el-upload
            class="avatar-uploader"
            action="frontsideup"
            :show-file-list="false"
            :before-upload="beforefrontSideUp"
            :http-request="UploadfrontSide"
            v-loading="frontSideLoading"
            >
            <img :src="frontSide" class="avatar">
            <div class="idcard_tip">点击上传身份证正面</div>
          </el-upload>
          <!-- 背面 -->
          <el-upload
            class="avatar-uploader"
            action="backsideup"
            :show-file-list="false"
            :before-upload="beforefrontSideUp"
            :http-request="UploadbackSide">
            <img :src="backSide" class="avatar">
            <div class="idcard_tip">点击上传身份证背面</div>
          </el-upload>    
          <!-- 免冠 -->
          <el-upload
            class="avatar-uploader"
            action="crownfreeup"
            :show-file-list="false"
            :before-upload="beforefrontSideUp"
            :http-request="beforecrownFreeUp">
            <img :src="crownFree" class="avatar">
            <div class="idcard_tip">点击上传本人现场半身照</div>
          </el-upload>
          <!-- 姓名及证件号码框 -->
          <el-dialog title="请确定身份信息，如有错误可手动修改" width="500px" :center="true" :visible.sync="idCardDialogVisible">
            <el-form>
              <el-form-item label="姓名：" :label-width="formLabelWidth">
                <el-input v-model="idcardName" autocomplete="off" style="width:250px;"></el-input>
              </el-form-item>
              <el-form-item label="证件号码：" :label-width="formLabelWidth">
                <el-input v-model="idcardCode" :disabled="true" autocomplete="off" :maxlength="18" style="width:250px;"></el-input>
              </el-form-item>
              <el-form-item label="证件地址：" :label-width="formLabelWidth">
                <el-input type="textarea" v-model="idcardadd" autocomplete="off" style="width:250px;"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="idCardDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="idCardDialogVisible = false">确 定</el-button>
            </div>
          </el-dialog>

          <el-dialog title="请确定身份信息，如有错误可手动修改" width="500px" :center="true" :visible.sync="idCardDialogVisible1">
            <el-form>
              <el-form-item label="证件有效期：" :label-width="formLabelWidth">
                <el-input v-model="idcardTime" autocomplete="off" style="width:250px;"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="idCardDialogVisible1 = false">取 消</el-button>
              <el-button type="primary" @click="idCardDialogVisible1 = false">确 定</el-button>
            </div>
          </el-dialog>
        </div>
        <div class="tipbox" style="line-height:23px;">
          <div style="color:red;padding:20px 0 5px;letter-spacing: 1px;font-size:17px;">温馨提示：</div>
          <div>1、拍摄时保证证件上信息及人像清晰可见；</div>
          <div>2、本人现场半身照必须现场拍摄，不可使用身份证正面照片或证件照；</div>
          <div>3、号卡激活时，必须上传与预约人相同的证件信息；</div>
          <div>4、30日之内，每个身份信息只能激活1张信时空号卡；</div>
          <div>5、请您确认所上传照片及身份信息真实有效，上传照片应符合电信用户实名制入网规范。如上传图片涉嫌翻拍、造假、违规拍照，造成号卡无法激活的，购卡人需自行承担后果。</div>
        </div>
      </div>

      <!-- 购买信息 -->
      <div class="buyInfo">
        <!-- <div class="buyInfoLeft">
          <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">号码等级：</span><span class="buyInfoLeft_item_con">靓号</span></div>
          <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">已选号码：</span><span class="buyInfoLeft_item_con">170 9006 8900</span></div>
          <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">归属地：</span><span class="buyInfoLeft_item_con">广东 深圳</span></div>
          <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">已选套餐：</span><span class="buyInfoLeft_item_con">2019无限时空49元档</span></div>
        </div> -->
        <div class="buyInfoRight">
          <!-- <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">首月服务费：</span><span class="buyInfoRight_item_con">￥880.00</span></div>
          <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">套餐预存费：</span><span class="buyInfoRight_item_con">￥100.00</span></div>
          <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">首月服务费优惠：</span><span class="buyInfoRight_item_con">￥-00.00</span></div>
          <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">套餐预存费优惠：</span><span class="buyInfoRight_item_con">￥-00.00</span></div> -->
          <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">运费：</span><span class="buyInfoRight_item_con">￥{{(postCost/100).toFixed(2)}}</span></div>
          <!-- <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">订单总计：</span><span class="buyInfoRight_item_con">￥980.00</span></div> -->
        </div>
      </div>

      <div class="payInfo">
        <!-- <div class="last_step">
          <span class="last_step_btn" @click="gotoStepTwo">上一步</span>
        </div> -->
        <div class="next_step">
          <span class="next_step_title">实付金额：</span>
          <span class="next_step_money">¥{{(cardMoneyandpostCost/100).toFixed(2)}}</span>
          <span class="next_step_btn cursor" @click="gotoStepFour">下一步</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
export default {
  name: "stepThree",
  props: {
    orderid: String,
    cardMoney : Number,
    needImg : String
  },
  data(){
    return {
      token : window.localStorage.getItem('token'),
      loading : '',
      frontSideLoading : false,
      buyUserPhone : '',
      userName : '',
      userPhone : '',
      userAdd : '',
      userAddProvince : '',
      userAddCity : '',
      userAddInfo : '',
      frontSide: require('../../assets/frontSideDefault.png'),
      backSide: require('../../assets/backSideDefault.png'),
      crownFree: require('../../assets/crownFreeDefault.png'),
      crownFreeflag : false,
      options: require('../../assets/city.json'),
      fileReader : '',
      idCardDialogVisible: false,
      idCardDialogVisible1: false,
      formLabelWidth: '120px',
      idcardName : '',
      idcardCode : '',
      idcardTime : '',
      idcardadd : '',
      postCost : 0,
      cardMoneyandpostCost : 0,
    }
  },
  methods: {
    Loading : function(text){
      this.loading = Loading.service({
        lock: true,
        text: text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    alertMsg : function(msg){
      this.$message({
        message: msg,
        type: 'error',
        offset: '300'
      });
    },
    handlebuyUserPhone(){
      this.buyUserPhone = this.buyUserPhone.replace(/[^\w]/g, '');
    },
    //根据地址获取运费
    addChange(city){
      if(this.userAdd != ''){
        this.Loading('正在计算运费...')
        this.userAddProvince = city[0];
        this.userAddCity = city[1];
        var that = this;
        var params = {
          "token": this.token,
          "province": this.userAddProvince,
          "city": this.userAddCity,
          "sdk_order_id": this.orderid
        }
        this.$http.post('/getPostCost',params,{emulateJSON: true})
        .then(function(res){ 
          var data = res.data;
          if(data.code == '200'){
            that.loading.close();
            that.postCost = data.data.postCost;
            that.cardMoneyandpostCost = parseInt(that.cardMoney) + parseInt(data.data.postCost);
          }else{
            that.loading.close();
            that.alertMsg('运费查询失败');
          }
        }).catch(function(err){ 
          that.alertMsg('运费查询失败');
        }) 
      }
    },
    //检测照片格式及大小
    beforefrontSideUp(file) {
      var isIMAGE = true;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (file.type === 'image/jpeg' || file.type === 'image/png' ) {
      }else{
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
        isIMAGE = false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isIMAGE && isLt2M;
    },
    //正面
    UploadfrontSide(param){
      this.Loading('正在识别身份信息...')
      var that = this;
      let file = param.file
      let filename = file.name
      if (file) {
        this.fileReader.readAsDataURL(file)
      }
      this.fileReader.onload = () => {
        let base64Str = (this.fileReader.result).split(',')[1];
        var params = {
          "token": this.token,
          "imgNo": '1',
          "img": base64Str,
          "sdk_order_id": this.orderid
        }
        this.$http.post('/imgUpload',params,{emulateJSON: true})
        .then(function(res){ 
          that.loading.close();
          var data = res.data;
          if(data.code == '200'){
            that.frontSide = that.fileReader.result;
            that.idCardDialogVisible = true;
            that.idcardName = data.data.idName;
            that.idcardadd = data.data.idAddress;
            that.idcardCode = data.data.idNum;
          }else{
            that.alertMsg(data.msg);
          }
        }).catch(function(err){ 
          that.loading.close();
          that.alertMsg('身份信息识别失败，请重新上传');
        }) 
      }
    },
    //背面
    UploadbackSide : function(param){
      this.Loading('正在识别身份信息...')
      var that = this;
      let file = param.file
      let filename = file.name
      if (file) {
        this.fileReader.readAsDataURL(file)
      }
      this.fileReader.onload = () => {
        let base64Str = (this.fileReader.result).split(',')[1];
        var params = {
          "token": this.token,
          "imgNo": '2',
          "img": base64Str,
          "sdk_order_id": this.orderid
        }
        this.$http.post('/imgUpload',params,{emulateJSON: true})
        .then(function(res){ 
          that.loading.close();
          var data = res.data;
          if(data.code == '200'){
            let endtime = data.data.idPeriod.split('-')[1];
            let nowdate = new Date();
            let enddate = new Date(endtime);
            if(nowdate>enddate){
              that.alertMsg('身份证已过期，请重新上传');
            }else{
              that.idCardDialogVisible1 = true;
              that.idcardTime = data.data.idPeriod;
              that.backSide = that.fileReader.result;
            }
          }else{
            that.alertMsg(data.msg);
          }
        }).catch(function(err){ 
          that.loading.close();
          that.alertMsg('身份信息识别失败，请重新上传');
        }) 
      }
    },
    //免冠
    beforecrownFreeUp(param) {
      this.Loading('正在上传...')
      var that = this;
      let file = param.file;
      let filename = file.name;
      if (file) {
        this.fileReader.readAsDataURL(file)
      }
      this.fileReader.onload = () => {
        let base64Str = (this.fileReader.result).split(',')[1];
        var params = {
          "token": this.token,
          "imgNo": '3',
          "img": base64Str,
          "sdk_order_id": this.orderid
        }
        this.$http.post('/imgUpload',params,{emulateJSON: true})
        .then(function(res){ 
          that.loading.close();
          var data = res.data;
          if(data.code == '200'){
            that.crownFree = that.fileReader.result;
            that.crownFreeflag = true;
          }else{
            that.crownFreeflag = false;
            that.alertMsg(data.msg);
          }
        }).catch(function(err){ 
          that.loading.close();
          that.alertMsg('上传失败，请重新上传');
          that.crownFreeflag = false;
        }) 
      }
    },
    tipFunc : function(){
      var that = this;
      var msg = '<div>根据国家工信部 《实名制登记公告》 ，用户通过网络办理新号码须上传身份证照片并通过实名验证，请您在收到号卡后按照激活流程进行实名制认证</div><div>图片说明：</div><div>1.照片格式需使用JPG、PNG等通用格式，最大不大于2M；</div><div>2.照片像素需不低于48万、照片长宽比建议为16:9或4:3；</div>3.证件照中的文字需保持清晰可辨。<div></div>'
      this.$confirm(msg, '', {
        showClose: false, //是否显示右上角关闭按钮
        showConfirmButton: true, //是否显示确定按钮
        confirmButtonText: '知道啦', //确定按钮的文本内容
        showCancelButton: false, //取消按钮的文本内容
        dangerouslyUseHTMLString: true, //是否将message属性作为HTML片段处理
        roundButton: true //是否使用圆角按钮
      })
      .then(() => {})
      .catch(action => {})
    },
    checkInfo : function(){
      var that = this;
      var params = {
        'token' : this.token,
        'idName' : this.idcardName,
        'idNum' : this.idcardCode,
        'idPeriod' : this.idcardTime,
        'idAddress' : this.idcardadd,
        'sdk_order_id' : this.orderid
      }
      this.$http.post('/checkInfo',params,{emulateJSON: true})
      .then(function(res){ 
        that.loading.close();
        var data = res.data;
        if(data.code == '200'){
          that.checkInfoResult();
        }else{
          that.alertMsg(data.msg);
        }
      }).catch(function(err){ 
        that.loading.close();
        that.alertMsg('提交预审失败，请重新提交');
      }) 
    },
    checkInfoResult : function(){
      var that = this;
      this.Loading('正在调取预审结果...')
      var params1 = {
        "token": this.token,
        "sdk_order_id": this.orderid
      }
      var timer = setInterval(function(){
        that.$http.post('/checkInfoResult',params1,{emulateJSON: true})
        .then(function(res1){ 
          var resdata = res1.data;
          if(resdata.code == '200'){
            if(resdata.data.result == '1'){
              clearInterval(timer);
              that.loading.close();
              that.submitInfo()
            }else if(resdata.data.result == '0'){
            }else{
              that.loading.close();
              clearInterval(timer);
              that.alertMsg(resdata.data.desc);
            }
          }else{
            that.alertMsg(resdata.msg);
          }
        }).catch(function(err){ 
          that.loading.close();
          that.alertMsg('调取预审结果失败，请重新提交');
        })
      },2000)
    },
    submitInfo : function(){
      var that = this;
      this.Loading('正在保存订单信息...');
      var params2 = {
        "token": this.token,
        "sdk_order_id": this.orderid,
        "linkPhone": this.buyUserPhone,
        "postPhone": this.userPhone,
        "postAddress": this.userAdd + this.userAddInfo,
        "postName": this.userName,
        //"postalCode": "100000", //邮编
        "postMoney": this.postCost
      }
      this.$http.post('/submitInfo',params2,{emulateJSON: true})
      .then(function(res2){ 
        var resdata2 = res2.data;
        that.loading.close();
        if(resdata2.code == '200'){
          that.$emit('gotoStepFourFunc',3);
        }else{
          that.alertMsg(resdata2.msg);
        }
      }).catch(function(err){ 
        that.loading.close();
        that.alertMsg('保存订单信息失败，请重新提交');
      })
    },
    //上一步
    // gotoStepTwo : function(){
    //   this.$emit('gotoStepTwoFunc',1);
    // },
    
    //下一步
    gotoStepFour : function(){
      
      if(this.buyUserPhone == ''){
        this.alertMsg('请填写购卡人联系电话');
        return;
      }
      if(this.userPhone == ''){
        this.alertMsg('请填写收货人联系电话');
        return;
      }
      if(this.userName == ''){
        this.alertMsg('请填写收货人姓名');
        return;
      }
      if(this.userAdd == '' || this.userAddInfo == ''){
        this.alertMsg('请完整填写收货地址');
        return;
      }
      if(this.needImg == '1'){
        if(this.idcardName == '' || this.idcardCode == '' || this.idcardadd == ''){
          this.alertMsg('请上传身份证正面照片');
          return;
        }
        if(this.idcardTime == ''){
          this.alertMsg('请上传身份证背面照片');
          return;
        }
        if(!this.crownFreeflag){
          this.alertMsg('请上传免冠照片');
          return;
        }
      }
      if(this.needImg == '1'){
        this.checkInfo();
      }else{
        this.submitInfo()
      }
      // var that = this;
      // var params = {
      //   'token' : this.token,
      //   'idName' : this.idcardName,
      //   'idNum' : this.idcardCode,
      //   'idPeriod' : this.idcardTime,
      //   'idAddress' : this.idcardadd,
      //   'sdk_order_id' : this.orderid
      // }
      // this.$http.post('/checkInfo',params,{emulateJSON: true})
      // .then(function(res){ 
      //   that.loading.close();
      //   var data = res.data;
      //   if(data.code == '200'){
      //     that.Loading('正在调取预审结果...')
      //     var params1 = {
      //       "token": this.token,
      //       "sdk_order_id": that.orderid
      //     }
      //     var timer = setInterval(function(){
      //       that.$http.post('/checkInfoResult',params1,{emulateJSON: true})
      //       .then(function(res1){ 
      //         var resdata = res1.data;
      //         if(resdata.code == '200'){
      //           if(resdata.data.result == '1'){
      //             clearInterval(timer);
      //             that.loading.close();
      //             that.Loading('正在保存订单信息...')
      //             var params2 = {
      //               "token": this.token,
      //               "sdk_order_id": that.orderid,
      //               "linkPhone": that.buyUserPhone,
      //               "postPhone": that.userPhone,
      //               "postAddress": that.userAdd + that.userAddInfo,
      //               "postName": that.userName,
      //               "postalCode": "100000",
      //               "postMoney": that.postCost
      //             }
      //             that.$http.post('/submitInfo',params2,{emulateJSON: true})
      //             .then(function(res2){ 
      //               console.log("12334")
      //               var resdata2 = res2.data;
      //               that.loading.close();
      //               if(resdata2.code == '200'){
      //                 that.$emit('gotoStepFourFunc',3);
      //               }else{
      //                 that.alertMsg(resdata2.msg);
      //               }
      //             }).catch(function(err){ 
      //               that.loading.close();
      //               that.alertMsg('保存订单信息失败，请重新提交');
      //             })
      //           }else if(resdata.data.result == '0'){
      //           }else{
      //             that.loading.close();
      //             clearInterval(timer);
      //             that.alertMsg(resdata.data.desc);
      //           }
      //         }else{
      //           that.alertMsg(resdata.msg);
      //         }
      //       }).catch(function(err){ 
      //         that.loading.close();
      //         that.alertMsg('调取预审结果失败，请重新提交');
      //       })
      //     },2000)
      //   }else{
      //     that.alertMsg(data.msg);
      //   }
      // }).catch(function(err){ 
      //   that.loading.close();
      //   that.alertMsg('提交预审失败，请重新提交');
      // }) 
    },
  },
  beforeMount : function(){
    this.loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  },
  mounted:function(){
    console.log(this.needImg)
    this.cardMoneyandpostCost = parseInt(this.cardMoney);
    var that = this;
    this.fileReader = new FileReader();
    // setTimeout(function(){
    //   that.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
        that.loading.close();
    //   });
    // },1000)
  },
  watch:{
    'buyUserPhone': function (curVal, oldVal) {
      if (!curVal) {
        this.buyUserPhone = ''
        return false
      }
      // 实时把非数字的输入过滤掉
      this.buyUserPhone = curVal.match(/\d/ig) ? curVal.match(/\d/ig).join('') : ''
    },
    'userPhone': function (curVal, oldVal) {
      if (!curVal) {
        this.userPhone = ''
        return false
      }
      // 实时把非数字的输入过滤掉
      this.userPhone = curVal.match(/\d/ig) ? curVal.match(/\d/ig).join('') : ''
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.steptThree {
  .cursor {
    cursor: pointer;
  }
  text-align: left;
  .userInfo {
    .userInfoItem {
      padding-bottom: 30px;
      .userInfoItem_title {
        color: #303133;
        font-size: 18px;
        font-weight:500;
        line-height:24px;
        padding: 0 0 10px 2px;
      }
      .userInfoItem_con {
        .buyUserPhoneInp {
          width: 350px;
        }
        .userName,.userPhone {
          width: 260px;
          margin-right: 20px;
          margin-bottom: 10px;
        }
        .userAdd {
          width: 540px;
          margin-bottom: 10px;
        }
        .userAddInfo {
          width: 540px;
          margin-bottom: 10px;
        }
        .idcard_tip {
          color: #1989FA;
          font-size: 14px;
          line-height:40px;
        }
      }
      .idcard_list {
        display: flex;
      }
    }
    .idcard_box {
      padding-bottom: 40px;
      border-bottom: 1px solid #E9E9E9; 
      .userInfoItem_title {
        position: relative;
        .tip {
          position: absolute;
          right: 0;
          color: #1989FA;
          font-size: 16px;
        }
      }
    }
    .buyInfo {
      padding: 40px 50px;
      display: flex;
      justify-content: flex-end;
      font-size: 18px;
      line-height: 30px;
      color: #909399;
      border-bottom: 1px solid #E9E9E9; 
      .buyInfoLeft {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .buyInfoLeft_item_title {
          display: inline-block;
          width: 100px;
          text-align: left;
        }
        .buyInfoLeft_item_con {
          color: #303133;
        }
      }
      .buyInfoRight {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .buyInfoLeft_item_title {
          display: inline-block;
          width: 160px;
          text-align: right;
        }
        .buyInfoRight_item_con {
          display: inline-block;
          width: 80px;
          color: #5CB87A;
          text-align: right;
        }
      }
    }
    .payInfo {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 60px 50px 50px 0;
      .last_step {
        .last_step_btn {
          font-size: 14px;
          padding: 10px 25px;
          border: 1px solid #DCDFE6;
          border-radius:4px;
          color: #606266;
        }
      }
      .next_step {
        display: flex;
        align-items: flex-end;
        .next_step_title {
          color: #606266;
          font-size: 16px;
          line-height: 24px;
          padding-right: 10px;
        }
        .next_step_money {
          font-size: 36px;
          line-height: 36px;
          color: #1989FA;
          padding-right: 20px;
        }
        .next_step_btn {
          background: #1989FA;
          color: #FFFFFF;
          font-size: 22px;
          border-radius:6px;
          height: 50px;
          line-height: 50px;
          padding: 0 30px;
        }
      }
    }
  }
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
<style lang="less">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-right: 20px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar {
  width: 240px;
  height: 135px;
  padding: 15px 15px 0;
  display: block;
}
</style>